import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function ContactCta() {
  return (
    <section aria-labelledby="home-contact" className="mx-auto max-w-content px-4 pb-4 md:px-6">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-8 md:p-12">
            <h2 id="home-contact" className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              发现疑似不实信息？
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              把原始链接、截图和传播时间提交给我们。我们会按顺序核查，并把结论同步到声明公告库，让更多人看到官方口径。
            </p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
              >
                <span className="flex h-4 w-4 items-center justify-center"><i className="ri-send-plane-line" /></span>
                前往提交线索
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 cursor-pointer"
              >
                <span className="flex h-4 w-4 items-center justify-center"><i className="ri-information-line" /></span>
                了解平台定位
              </Link>
            </div>
          </div>
          <div className="border-t border-background-200 bg-background-50 p-8 md:p-12 lg:border-l lg:border-t-0">
            <h3 className="font-heading text-base font-bold text-foreground-950">其他联系方式</h3>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-accent-100 text-lg text-accent-800">
                  <i className="ri-mail-line" />
                </span>
                <span>
                  <span className="block text-foreground-500">澄清与核实</span>
                  <span className="break-all text-foreground-900">{siteInfo.email}</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-accent-100 text-lg text-accent-800">
                  <i className="ri-alarm-warning-line" />
                </span>
                <span>
                  <span className="block text-foreground-500">举报冒名与诈骗</span>
                  <span className="break-all text-foreground-900">{siteInfo.reportEmail}</span>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-9 w-9 flex-none items-center justify-center rounded-md bg-accent-100 text-lg text-accent-800">
                  <i className="ri-time-line" />
                </span>
                <span>
                  <span className="block text-foreground-500">服务时间</span>
                  <span className="text-foreground-900">{siteInfo.serviceHours}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}